<template>
  <shared-product-edit :product="product" :images="images">
    <div class="l-col-4@md" slot="attributes">
      <div class="margin">
        <strong>{{ $t('color.label') }}</strong>
        {{ product.color }}
      </div>
    </div>
    <div class="l-col-4@md" slot="attributes">
      <div class="margin">
        <strong>{{ $t(`netshoes.gridType.${product.gridType}.label`) }}</strong>
        {{ product.grid }}
      </div>
    </div>
  </shared-product-edit>
</template>

<script>
  import SharedProductEdit from '@/components/marketplace/shared/ProductEdit'

  export default {
    props: {
      product: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatProduct () {
        return {}
      }
    },
    computed: {
      images () {
        return this.product.images.map(image => image.url)
      }
    },
    components: {
      SharedProductEdit
    }
  }
</script>

<style lang="sass" scoped>
  .margin
    margin-top: 10px
</style>



// WEBPACK FOOTER //
// ProductEdit.vue?2b48bb9a